/*
|--------------------------------------------------------------------------
| Utilities: Fetch: JSON
|--------------------------------------------------------------------------
*/
/**
 * @namespace
 */
__gh__webApp.utilities.fetch.json = {

	"addJSONToCallbackData": function(json,callbacks){
		// add json data to callbacks
		for (var i=0; i<callbacks.length; i++){
			var callbackObj 		= callbacks[i],
				data 				= ("data" in callbacks[i]) ? callbackObj.data : {};
				data.json			= json;
				callbacks[i].data 	= data;
		}
		return callbacks;
	},

	/**
	 * Get json data and save to an object
	 *
	 * @param {object} options
	 * @param {string} options.url - url to get the json from
	 * @param {boolean} options.async - async is true or false
	 * @param {array} options.callbacks - array of callback objects [{"callback": "Function.path.name.goes.here","data":{}}]
	 */
	"get" : function(options) {
		var commonJS		= __gh__webApp.common,
			url 			= (options.url) ? options.url : null,
			async			= (options.async) ? options.async : false,
			callbacks		= (options.callbacks) ? options.callbacks : null,
			errorCallbacks	= (options.errorCallbacks) ? options.errorCallbacks : null,
			urlParams		= commonJS.getURLParamsAsObject(url),
			dataType		= ("jsonp" in urlParams && urlParams.jsonp) ? "jsonp" : "json",
			jsonpCallback	= (dataType=="jsonp" && "callback" in urlParams) ? urlParams.callback : null,
			json 	= {
				"main": [
					{
					  "success": false,
					  "message": "no items to display"
					}
				]
			};
	
		if(!url){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.utilities.fetch.json.get",message:"Missing url."});
		}
		
	
		function handleCallbacks(data,callbacks){
				if (callbacks){
					var updatedCallbacks = __gh__webApp.utilities.fetch.json.addJSONToCallbackData(data,callbacks);
						commonJS.callArrayOfFunctions(updatedCallbacks);
				}
		}
	
		url = commonJS.noCacheURL(url);
		
		ajaxOptions = {
		    "async"			: async,
		    "global"		: false,
		    "url"			: url,
			"dataType"		: dataType,
		    success: function(data) {
				json = data;
				handleCallbacks(json,callbacks);
		    },
		    error: function(e) {
			    __gh__webApp.utilities.errorLog({controller:"__gh__webApp.utilities.fetch.json.get",message:"URL:"+url+"Error: Ajax request failed"});
			    handleCallbacks(json,errorCallbacks);
		    }
	    };
	    
	    if (jsonpCallback){
		    ajaxOptions.jsonpCallback = jsonpCallback;
	    }
	
	    $.ajax(ajaxOptions);
	
	    if (!async){
			return json;
	    }
	}
};
